export function selectBasedOnError(
  ...conditions: [error: any, whenError: () => void][]
) {
  return conditions.find((a) => !!a[0])?.[1] || (() => {})
}
